export default __webpack_public_path__ + "static/media/lp-new-backfit-header-desktop.049e6425.jpg";